import React from 'react';
import './ColouredLoadingSymbol.css';
import STC from '../../STCFactory/STCFactory';


export default function ColouredLoadingSymbol({message}){

    return(
        <div className='coloured-loading-symbol'>
            <div className='coloured-loader'>
                <div>{message ? message : <STC.Logo.Bordered style={{height: '50%'}}/> }</div>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    )
}